import { getTenantSlugFromPathname } from "~/lib/tenant-routing";

/**
 * Extract a tenant slug from the current URL path.
 *
 * Examples:
 *   /uni1/dashboard        → "uni1"
 *   /unimelb/apply/new     → "unimelb"
 *   /dashboard             → null
 *   /login                 → null
 */
export function getTenantSlugFromPath(): string | null {
  if (typeof window === "undefined") return null;
  return getTenantSlugFromPathname(window.location.pathname);
}
